import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpClient = inject(HttpClient);

  public logout(): void {
    const logoutUrl = environment.host + 'accounts/logout/';
    const redirectToHost = () => {
      window.location.href = environment.host;
    };

    this.httpClient.post(logoutUrl, {}).subscribe({
      next: redirectToHost,
      error: redirectToHost,
    });
  }
}
